/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const BackOfficeCardStatusDtoV1 = {
    OK: 'OK',
    PRE_ORDER: 'PRE_ORDER',
    FROZEN: 'FROZEN',
    BLOCKED: 'BLOCKED',
    TERMINATED: 'TERMINATED',
    TERMINATED_DUE_TO_FRAUD: 'TERMINATED_DUE_TO_FRAUD',
    SUSPECTED_FRAUD: 'SUSPECTED_FRAUD'
} as const;

export type BackOfficeCardStatusDtoV1 = typeof BackOfficeCardStatusDtoV1[keyof typeof BackOfficeCardStatusDtoV1];



